<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "ItemFileSetting"
}
</script>

<style scoped>

</style>